import React, { useState } from 'react';

import styled from 'styled-components';

import { VIEW_CATEGORY } from 'components/View/constants';
import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { useAppSelector } from 'store/hook';

import SidebarMenuAddView from './SidebarMenuAddView';
import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';
import { ACTOR_TYPE } from '../../../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectorIcon = styled.span`
  width: 18px;
  height: 18px;
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    width: 9px;
    height: 6px;
    margin: 6px 4.5px;
    background-image: url('/icons/dropdown-caret-down.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const SidebarMenuDefaultCommunityViews = () => {
  const { views, selectedCommunity } = useAppSelector((state) => state.global);
  const [showCustomViews, setShowCustomViews] = useState<boolean>(true);
  const safeViews = views ?? [];

  const communityType =
    selectedCommunity?.type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR
      ? ACTOR_TYPE.COMPETITOR
      : ACTOR_TYPE.COMMUNITY;

  const customCompanyViews = safeViews.length ? safeViews.filter((view) => view.category === VIEW_CATEGORY.CUSTOM) : [];

  return (
    <Container>
      <SidebarMenuCategoryHeader title={'CUSTOM VIEWS'}>
        <SelectorIcon onClick={() => setShowCustomViews(!showCustomViews)} />
      </SidebarMenuCategoryHeader>
      {showCustomViews &&
        customCompanyViews?.map((item, index) => (
          <SidebarMenuItem
            key={item.id}
            to={`/${communityType}/${selectedCommunity?.id}/view/${item.id}`}
            label={item.name}
          />
        ))}
      <SidebarMenuCategoryHeader>
        <SidebarMenuAddView />
      </SidebarMenuCategoryHeader>
    </Container>
  );
};

export default SidebarMenuDefaultCommunityViews;
